var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ReportingSettings", {
    attrs: {
      "available-filters": _vm.availableCallLogsFilters,
      "default-title": _vm.$t("DEFAULT_CALL_LOGS_TITLE"),
      "active-report": _vm.activeCallLog,
      "report-type": _vm.reportType,
      "time-range": _vm.activeCallLogTimeRange,
      "time-zone-id": _vm.activeCallLogTimeZoneId,
      "translated-time-zone-id": _vm.activeCallLogTranslatedTimeZoneId,
      "last-updated": _vm.activeCallLogLastUpdated,
      "filter-criteria": _vm.activeCallLogFilterCriteria,
      "view-as": _vm.activeCallLogViewAs,
      "view-as-publishers": _vm.viewAsPubs,
      "view-as-buyers": _vm.viewAsBuyers,
      "view-as-buyer-managers": _vm.viewAsBuyerManagers,
      "view-as-pub-managers": _vm.viewAsPubManagers,
      "quick-filters": _vm.callLogsQuickFilters,
      "form-name-for-user-settings": "reportingCallLogFilterUserSettings"
    },
    on: {
      saveReport: _vm.saveCallLogReport,
      deleteReport: _vm.deleteCallLogReport,
      duplicateReport: _vm.duplicateCallLogReport,
      refreshData: _vm.refreshCallLogsData,
      dateRangeChange: function($event) {
        return _vm.$emit("dateRangeChange")
      },
      viewAsChange: _vm.viewAsChange,
      onStartTour: function($event) {
        return _vm.$emit("onStartTour")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }